module.exports = __webpack_public_path__ + "static/media/galerija_2016 (4).f1282f65.jpg";